import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import SEO from '../components/seo'

const ReferPage = () => {
  const { calendarOgImage } = useStaticQuery(graphql`
    query ReferPageQuery {
      calendarOgImage: file(relativePath: { eq: "homepage/calendar-on-counter-desktop.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  return (
    <>
      <SEO
        title="Refer a Friend Discount | Skylight"
        description="Refer a friend, Give your friends $20 off and you'll get a $20 gift card after their first purchase"
        path="/refer"
        imagePath={calendarOgImage.childImageSharp.gatsbyImageData.images.fallback.src}
      />
      <div id="friendbuylandingpage" />
    </>
  )
}
export default ReferPage
